<template>
    <v-dialog v-model="dialog" width="500" scrollable>
        <template v-slot:activator="{ on }">
            <v-btn color="primary" v-on="on">New Sim</v-btn>
        </template>

        <v-card class="pa-2">
            <v-card-title class="pa-0 pl-1 pb-5 text-left font-weight-medium" primary-title>Номер:</v-card-title>
            <v-card-text class="pa-0 px-3 text-left">
                <v-text-field
                        v-model="fullname"
                        :error-messages="fullnameErrors"
                        @input="$v.fullname.$touch()"
                        @blur="$v.fullname.$touch()"
                        color="secondary"
                        class="pa-0 ma-0 my-2"
                        label="Описание"
                        counter="40"
                />
                <v-text-field
                        v-model="name"
                        :error-messages="nameErrors"
                        @input="$v.name.$touch()"
                        @blur="$v.name.$touch()"
                        color="secondary"
                        class="pa-0 ma-0 my-2"
                        label="Присвоенный внутренний номер"
                        counter="40"
                />
                <v-text-field
                        v-model="secret"
                        :error-messages="secretErrors"
                        @input="$v.secret.$touch()"
                        @blur="$v.secret.$touch()"
                        color="secondary"
                        class="pa-0 ma-0 my-2"
                        label="Пароль"
                        counter="40"
                />
                <v-row>
                    <v-col cols="12" class="pa-0 px-3 pr-sm-0">
                        <v-select
                                v-model="type_sim"
                                :items="сategories"
                                label="Оператор:"
                                persistent-hint
                                return-object
                                single-line

                                color="secondary"
                                class="pa-0 my-2"
                                item-color
                                dense
                        ></v-select>
                    </v-col>
                    <v-col cols="12" class="pa-0 px-3 pl-sm-0">
                        <v-switch
                                v-model="record_conversation"
                                class="ma-2"
                                label="записывать разговор"
                        ></v-switch>
                    </v-col>
                </v-row>
                <v-row>
                    <v-expansion-panels class="pa-0 px-4 mx-3 mb-5 elevation-2">
                        <v-expansion-panel>
                            <v-expansion-panel-header class="pa-0 ma-0">Детальная настройка:</v-expansion-panel-header>
                            <v-expansion-panel-content>
                                <v-text-field
                                        v-model="host"
                                        color="secondary"
                                        class="pa-0 mb-2 mt-0"
                                        label="Разрешенный Ip-адрес устройство (хост)"
                                        counter="40"
                                />
                                <v-select
                                        v-model="type"
                                        :items="types"
                                        color="secondary"
                                        class="pa-0 mb-2 mt-9"
                                        item-color
                                        label="Тип (type) входящий, исходящий, смешанный"
                                        dense
                                ></v-select>
                                <v-text-field
                                        v-model="context"
                                        color="secondary"
                                        class="pa-0 mb-2 mt-9"
                                        label="Группа-множество номеров (context)"
                                        counter="40"
                                />
                            </v-expansion-panel-content>
                        </v-expansion-panel>
                    </v-expansion-panels>
                </v-row>
            </v-card-text>

            <v-card-actions class="buttons-group justify-end pa-0 pt-3">
                <v-btn
                        class="primary text--darken-4 py-2 px-4"
                        small
                        height="auto"
                        dark
                        @click="deleteSippeer()"
                >Удалить
                </v-btn>
                <v-btn
                        class="primary text--darken-4 py-2 px-4"
                        small
                        height="auto"
                        dark
                        @click="close()"
                >Закрыть
                </v-btn>
                <v-btn
                        class="primary text--darken-4 py-2 px-4"
                        small
                        height="auto"
                        dark
                        @click="save()"
                >Сохранить
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>

    import axios from 'axios'
    import { validationMixin } from 'vuelidate'
    import { required, maxLength } from 'vuelidate/lib/validators'

    export default {
        name: 'AddSimModal',

        mixins: [validationMixin],

        validations: {
            fullname: { required, maxLength: maxLength(40) },
            name: { required, maxLength: maxLength(40) },
            secret: { required, maxLength: maxLength(40) },
        },

        props: {
            object_id: {
                default: -1,
            },
        },

        data: () => ({
            dialog: false,

            types: ['friend', 'user', 'peer'],
            сategories: ['KyivStar', 'Vodafone', 'LifeCell'],

            id_sippeer: 0,
            fullname: '',
            name: '',
            secret: '',
            host: '',
            type: '',
            context: '',
            type_sim: 'KyivStar',

            // записывать разговор:
            record_conversation: false,
        }),

        watch: {
            object_id: function () {

                console.log('watch(): ' + this.object_id)

                if (this.object_id > 0){
                    this.id_sippeer = this.object_id
                    this.getSippeer(this.id_sippeer)
                }
            },
        },

        computed: {
            fullnameErrors () {
                const errors = []
                if (!this.$v.fullname.$dirty) return errors
                !this.$v.fullname.maxLength && errors.push('fullname must be at most 40 characters long')
                !this.$v.fullname.required && errors.push('fullname is required.')
                return errors
            },
            nameErrors () {
                const errors = []
                if (!this.$v.name.$dirty) return errors
                !this.$v.name.maxLength && errors.push('name must be at most 40 characters long')
                !this.$v.name.required && errors.push('name is required.')
                return errors
            },
            secretErrors () {
                const errors = []
                if (!this.$v.secret.$dirty) return errors
                !this.$v.secret.maxLength && errors.push('secret must be at most 40 characters long')
                !this.$v.secret.required && errors.push('secret is required.')
                return errors
            },
        },

        methods: {
            /**
             * Получить sippeer для редактирования.
             *
             * @param id_extension
             */
            getSippeer (id_sippeer) {
                axios({
                    method: 'get',
                    url: process.env.VUE_APP_API_URL_PHONE + 'get-sim-card',
                    params: {
                        id_sippeer: id_sippeer,
                    },
                }).then((response) => {

                    console.log(response)

                    this.id_sippeer = response.data.id
                    this.fullname = response.data.fullname
                    this.name = response.data.name
                    this.secret = response.data.secret
                    this.host = response.data.host
                    this.type = response.data.type
                    this.context = response.data.context

                    this.type_sim = response.data.type_sim

                    if (response.data.record_conversation === 'yes') {
                        this.record_conversation = true
                    }
                }).catch(error => alert(error))

                this.dialog = true
            },

            /**
             * Удалить sippeer.
             */
            deleteSippeer () {

                axios({
                    method: 'post',
                    url: process.env.VUE_APP_API_URL_PHONE + 'delete-sim-card',
                    params: {
                        id_sippeer: this.id_sippeer,
                    },
                }).then((response) => {
                    console.log(response.data)
                }).catch(error => alert(error))

                this.close()
            },

            /**
             *  Сохранить sippeer.
             */
            save () {
                this.$v.$touch()

                if (!this.$v.$invalid) {

                    console.log(this.type)

                    // записывать разговор или нет:
                    let recordConversation = 'no'
                    if (this.record_conversation) {
                        recordConversation = 'yes'
                    }

                    axios({
                        method: 'post',
                        url: process.env.VUE_APP_API_URL_PHONE + 'set-sim-card',
                        params: {
                            id_sippeer: this.id_sippeer,
                            fullname: this.fullname,
                            name: this.name,
                            secret: this.secret,
                            host: this.host,
                            type: this.type,
                            context: this.context,
                            record_conversation: recordConversation,

                            type_sim: this.type_sim,
                        },
                    }).then((response) => {
                        console.log(response.data)
                    }).catch(error => alert(error))

                    this.close()
                }
            },

            /**
             * Закрыть модальное окно для редактирования sippeer и обнулить поля.
             */
            close () {
                this.dialog = false

                this.$v.$reset()
                this.id_sippeer = 0
                this.fullname = ''
                this.name = ''
                this.secret = ''
                this.host = ''
                this.type = ''
                this.context = ''
                this.record_conversation = false
                this.type_sim = 'KyivStar'

                this.$emit('closeModal');
            },
        },
    }

</script>

<style scoped>
</style>
